export default function removeElementById(elementId) {
  const element = document.getElementById(elementId);
  if (element) element.parentNode.removeChild(element);
}
